import { render, staticRenderFns } from "./CompanyComplaintMSDourada.vue?vue&type=template&id=3640947e&"
import script from "./CompanyComplaintMSDourada.vue?vue&type=script&lang=js&"
export * from "./CompanyComplaintMSDourada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports